export default __webpack_public_path__ + "static/media/You have earned 100% bonus point (final popup).9577bef0.svg";